import React, {Component} from 'react'

import style from './search.sass'

class Search extends Component {
  state = {
    searchStr: ''
  }
  handleChange = (e) => {
    this.setState({searchStr: e.target.value})
    this.props.onSearch(e.target.value)
  }
  render() {
    const {searchStr} = this.state
    const {loading, onSearch} = this.props

    if (typeof onSearch !== 'function') {
      return null
    }

    return(
      <div styleName={'search ' + (loading ? 'loading' : '')}>
        <input placeholder='Search' onChange={this.handleChange} value={searchStr}/>
      </div>
    )
  }
}

export default Search
